import "../styles/footer.scss";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="logo">
            <img src="/image/kimbal-urja-logo.png" alt="Urjā Logo" width="auto" />
          </div>

          <nav className="footer-nav">
            {/* <a href="/">Company</a>
            <a href="/">Solutions</a>
            <a href="/">Platform</a>
            <a href="/">Resources</a> */}
            <Link to="/LeadForm">Book Demo</Link>
          </nav>
        </div>

        <div className="footer-bottom">
          <p>© Copyright Urja by Kimbal 2026, All Rights Reserved</p>

          <div className="links">
            {/* <a href="/">Privacy Policy</a>
            <span>|</span>
            <a href="/">Terms and Conditions</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
